// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const SecurityProtectionSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="SecurityProtectionSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M7.214 12.023A6.9 6.9 0 0 1 6.3 9.613C6.122 8.588 6.183 7.496 6.483 6.361L10 5.02l3.354 1.277a5 5 0 0 0-.107-1.935l-.013-.046-2.86-1.09a1.04 1.04 0 0 0-.747 0L5.525 4.79a1.07 1.07 0 0 0-.65.72C4.473 6.99 4.388 8.424 4.623 9.78a8.7 8.7 0 0 0 .533 1.841 5 5 0 0 0 .78.267 4.7 4.7 0 0 0 1.278.136" />
      <path d="M15.096 5.435a.99.99 0 0 0-.603-.64L14.241 4.7a2.4 2.4 0 0 1 .21 1.587c-.362 1.676-1.24 3.197-2.539 4.397a9.2 9.2 0 0 1-4.685 2.296 2.75 2.75 0 0 1-1.488-.162c.796 1.361 2.061 2.73 4.023 3.949a.45.45 0 0 0 .474 0c6.48-4.07 5.364-9.681 4.86-11.331" />
      <path d="M16.172 5.216a2.25 2.25 0 0 0-1.362-1.501l-4.078-1.553a2.3 2.3 0 0 0-.816-.15V2.02a2.3 2.3 0 0 0-.648.143L5.19 3.716a2.25 2.25 0 0 0-1.362 1.501c-.486 1.766-.56 3.488-.223 5.115a10.3 10.3 0 0 0 1.67 3.816c1.422 2.03 3.242 3.22 3.958 3.636a1.7 1.7 0 0 0 .684.22v.008a1.7 1.7 0 0 0 .85-.23c.717-.416 2.537-1.605 3.958-3.636a10.3 10.3 0 0 0 1.67-3.816c.337-1.627.262-3.348-.223-5.115zm-.273 5.012a9.8 9.8 0 0 1-1.59 3.629c-1.363 1.948-3.11 3.089-3.797 3.489a1.2 1.2 0 0 1-.58.16v-.008a1.2 1.2 0 0 1-.444-.151c-.687-.4-2.433-1.54-3.797-3.489A9.8 9.8 0 0 1 4.1 10.23C3.782 8.68 3.854 7.04 4.318 5.352A1.74 1.74 0 0 1 5.371 4.19L9.45 2.637a1.8 1.8 0 0 1 .482-.11V2.519a1.8 1.8 0 0 1 .62.117l4.078 1.552a1.74 1.74 0 0 1 1.054 1.162c.464 1.69.537 3.33.216 4.878" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const SecurityProtectionSignetIcon = /* @__PURE__ */ Object.assign(
  SecurityProtectionSignetIconComponent,
  { displayName: 'SecurityProtectionSignetIcon' },
);
